import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMoscowmetroComponent } from './simple-icons-moscowmetro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMoscowmetroComponent ],
    exports:      [ SimpleIconsMoscowmetroComponent ],
    bootstrap:    []
})
export class SimpleIconsMoscowmetroModule {}
